import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "accordion-item" }
const _hoisted_2 = { class: "d-none" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["data-bs-target", "aria-controls"]
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "accordion-body" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "Permission name"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-200px" }, "Parent"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-50px" }, "Threshold")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2 border-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2 border-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2 border-2" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2 border-2" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_23 = { class: "svg-icon svg-icon-3 me-0" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_25 = { class: "svg-icon svg-icon-3 me-0 ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Keys = _resolveComponent("Keys")!
  const _component_Accounts = _resolveComponent("Accounts")!
  const _component_Waits = _resolveComponent("Waits")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.counter), 1),
    _createElementVNode("h2", {
      class: "accordion-header",
      id: `permission_header_${_ctx.index}`
    }, [
      _createElementVNode("button", {
        class: "accordion-button fs-4 fw-bold collapsed",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": `#permission_body_${_ctx.index}`,
        "aria-expanded": "false",
        "aria-controls": `permission_body_${_ctx.index}`
      }, " Permission #" + _toDisplayString(_ctx.index+1) + " : " + _toDisplayString(_ctx.permission.permName), 9, _hoisted_4)
    ], 8, _hoisted_3),
    _createElementVNode("div", {
      id: `permission_body_${_ctx.index}`,
      class: "accordion-collapse collapse",
      "aria-labelledby": "`permission_header_${index}`",
      "data-bs-parent": "#kt_accordion_1"
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (item, index) => {
                return _createElementVNode("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.permissionName) = $event)),
                      class: "form-control form-control-solid",
                      name: "permision"
                    }, null, 512), [
                      [_vModelText, _ctx.permissionName]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.permissionParent) = $event)),
                      class: "form-control form-control-solid",
                      name: "parent"
                    }, null, 512), [
                      [_vModelText, _ctx.permissionParent]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.permissionTreshold) = $event)),
                      class: "form-control form-control-solid",
                      name: "threshold"
                    }, null, 512), [
                      [_vModelText, _ctx.permissionTreshold]
                    ])
                  ])
                ])
              }), 64))
            ])
          ])
        ]),
        _hoisted_10,
        _hoisted_11,
        _createVNode(_component_Keys, {
          keys: _ctx.permission.requiredAuth.keys,
          onSetKeys: _ctx.setKeys
        }, null, 8, ["keys", "onSetKeys"]),
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _createVNode(_component_Accounts, {
          accounts: _ctx.permission.requiredAuth.accounts,
          onSetAccounts: _ctx.setAccounts
        }, null, 8, ["accounts", "onSetAccounts"]),
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _createVNode(_component_Waits, {
          waits: _ctx.permission.requiredAuth.waits,
          onSetWaits: _ctx.setWaits
        }, null, 8, ["waits", "onSetWaits"]),
        _hoisted_18,
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          (_ctx.permission.permName != 'active' && _ctx.permission.permName != 'owner')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-hover-rise btn-danger",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deletePermission()))
              }, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-sm btn-hover-rise btn-success ms-2",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save()))
          }, [
            _hoisted_24,
            _createElementVNode("span", _hoisted_25, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr012.svg" })
            ])
          ])
        ])
      ])
    ], 8, _hoisted_5)
  ]))
}